function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:none;stroke:#3A985C;stroke-width:2;}\n");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Noticia---web",
  transform: "translate(-591.000000, -104.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "migas-de-pan",
  transform: "translate(309.000000, 94.000000)"
}, /*#__PURE__*/React.createElement("polyline", {
  id: "Path-3-Copy-3",
  className: "st0",
  points: "282.74,10.68 286.74,15.04 282.74,19.4  "
}))));

var SvgSeparadorBreadcrumb = function SvgSeparadorBreadcrumb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 6.09 10.08",
    style: {
      enableBackground: "new 0 0 6.09 10.08"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSeparadorBreadcrumb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/separador_breadcrumb.43a0ca5c.svg";
export { ForwardRef as ReactComponent };